// Kept in sync with the two version-pinned dependency patches.
const PENDING_SELECTOR =
	'.bs-mapsight-embed[data-dehydrated-state]:not([data-bs-mapsight-ready])';
const READY_SELECTOR =
	'.bs-mapsight-embed[data-dehydrated-state][data-bs-mapsight-ready]';

export function isMapsightPending(element) {
	return !!element.closest(PENDING_SELECTOR);
}

export function onMapsightReady(enhance) {
	document.addEventListener('bs-mapsight-ready', (event) => {
		const root = event.target;
		if (
			root instanceof Element &&
			root.isConnected &&
			root.matches(READY_SELECTOR) &&
			!isMapsightPending(root)
		) {
			enhance(root);
		}
	});
}
